import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';

@Component({
  selector: 'cashback-info',
  templateUrl: '../sharedTemplates/cashback-info.component.html',
})
export class CashBackInfoComponent implements OnInit {
  depositList = [];
  cashbackBalance;

  result;

  constructor(
    private _ApiService: ApiService,
    public _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    public _Router: Router
  ) {
    //this.getStatus();
  }

  ngOnInit() {
    this._UiHelper.setNavbarTitle('CASHBACK', false);
  }

  getStatus() {
    this._ApiService.getCasbackStatus().then(res => {
      if (res && res.result && res.result < 0) {
        this.result = res.result;
      } else if (res && res.result && res.result > 0) {
        this.result = res.result;
        this.getCashbackBalance();
      }
    });
  }

  joinCashback() {
    if (this._UserHelper.isSignedIn) {
      this._Router.navigate(['/cashback']);
    } else {
      if (this._UiHelper.windowsWidth < 990) {
        this._UiHelper.b3000SetRightMenuState('open');
        this._UiHelper.b3000SetAcountMobileState('close');
      } else {
        this._UiHelper.loginDropDownOpen();
      }
    }
  }

  getCashbackBalance() {
    this._ApiService.getCashbackBalance().then(res => {
      if (res && res.CashBackBalance) {
        this.cashbackBalance = res.CashBackBalance;
      }
    });
  }
}
